import React from "react";
import { Card, Table, Skeleton } from "antd";
import { CheckCircleFilled, CloseCircleFilled, MinusCircleFilled } from "@ant-design/icons";
import { Title } from "components/common";
import { getTimeDateString } from "utils/date";
import styles from "./DashboardQuizzesV2.module.less";

const getAccuracyClass = (acc) => {
  const value = parseFloat(acc ?? 0);
  if (value >= 70) return styles.accuracyHigh;
  if (value >= 40) return styles.accuracyMed;
  return styles.accuracyLow;
};

const getAccuracyIcon = (acc) => {
  const value = parseFloat(acc ?? 0);
  if (value >= 70) return <CheckCircleFilled style={{ fontSize: 11 }} />;
  if (value >= 40) return <MinusCircleFilled style={{ fontSize: 11 }} />;
  return <CloseCircleFilled style={{ fontSize: 11 }} />;
};

const COLUMNS = [
  {
    title: "Quiz",
    dataIndex: "quizScriptName",
    key: "quizScriptName",
    render: (name) => <span className={styles.quizName}>{name || "—"}</span>,
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (date) => (
      <span className={styles.dateCell}>
        {date ? getTimeDateString(date, false, true) : "—"}
      </span>
    ),
  },
  {
    title: "Accuracy",
    dataIndex: "accuracy",
    key: "accuracy",
    render: (acc) => (
      <span className={`${styles.accuracyBadge} ${getAccuracyClass(acc)}`}>
        {getAccuracyIcon(acc)}
        {`${acc ?? "0"}%`}
      </span>
    ),
  },
];

const QuizzesSkeleton = () => (
  <Card className={styles.sectionCard}>
    <div className={styles.sectionHeader}>
      <Skeleton.Input active size="small" className={styles.skeletonTitle} />
    </div>
    <div className={styles.skeletonTableWrap}>
      <div className={styles.skeletonTableHeader}>
        <Skeleton.Input active size="small" className={styles.skeletonTableTh} />
        <Skeleton.Input active size="small" className={styles.skeletonTableTh} />
        <Skeleton.Input active size="small" className={styles.skeletonTableTh} />
      </div>
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className={styles.skeletonTableRow}>
          <Skeleton.Input active size="small" className={styles.skeletonTableTd} />
          <Skeleton.Input active size="small" className={styles.skeletonTableTd} />
          <Skeleton.Input active size="small" className={styles.skeletonTableTd} />
        </div>
      ))}
    </div>
  </Card>
);

const DashboardQuizzesV2 = ({ latestQuizzes = [], loading, isFetching }) => {
  if (loading) return <QuizzesSkeleton />;

  return (
    <Card className={styles.sectionCard}>
      <div className={styles.cardContentWrap}>
        <div className={styles.sectionHeader}>
          <Title level={5} className={styles.sectionTitle}>
            Latest Quizzes
          </Title>
        </div>

        <Card bordered className={styles.tableCard}>
          <Table
            columns={COLUMNS}
            dataSource={latestQuizzes}
            rowKey={(_, i) => i}
            pagination={false}
            size="small"
            loading={false}
            locale={{ emptyText: "No quizzes yet" }}
          />
        </Card>

        {isFetching && <div className={styles.shimmerOverlay} />}
      </div>
    </Card>
  );
};

export default DashboardQuizzesV2;
